module.exports = __webpack_public_path__ + "files/9a173d35e08313e74467bbf94c39cac4.png";